<template>
  <div class="exam__timer" :class="{'d-flex':!isTesting}">

    <div v-if="beforeFinish" class="exam__data-label" :class="{'auth-timer-label':!isTesting}">{{ getTranslation('timeLeft') }}</div>

    <div v-else class="exam__data-label" :class="{'auth-timer-label':!isTesting}">{{ getTranslation('beforeTestStart') }}</div>

    <div class="timer" :class="{'timer--early': !isStartTime,'auth-timer':!isTesting}">{{ prettyTime | prettify }}</div>

  </div>
</template>

<script>


export default {
  name: "TimerComponent",
  data() {
    return {
      timer: null,
      duration: 0,
      isPaused: false,
      beforeStart: false,
      beforeFinish: false,
      durationS: false,
      durationF: false,
      stopped: false,
    }
  },
  props: {
    isTesting: {
      type: Boolean,
      default: false,
    },
    testId: {
      required: false
    },
    durationStart: {
      type: Number,
      required: true
    },
    durationFinish: {
      type: Number,
      required: true
    }
  },

  created() {
    this.checkForDates();
    this.start();
  },
  beforeDestroy() {
    this.reset();
  },

  computed: {
    prettyTime() {
      let seconds = Math.trunc(this.duration % 60);
      let minutes = Math.trunc(this.duration / 60) % 60;
      let hours = Math.trunc(this.duration / 3600);
      return hours + ":" + minutes + ":" + seconds;
    },
    isStartTime() {
      return this.durationS < 1 || this.beforeFinish || this.durationStart < 1;
    }
  },
  watch: {
    'isStartTime'(val) {
      if (val) {
        this.duration = this.durationF;
        this.emitStartEvent();
      }
    },
    'durationStart'(val) {
      if (val < 1) {
        this.beforeFinish = true;
        this.beforeStart = false;

        this.duration = this.durationFinish;
        this.durationF = this.durationFinish;

        this.start(true);
      } else {
        this.beforeFinish = false;
        this.beforeStart = true;

        this.duration = this.durationStart;
        this.durationS = this.durationStart;
      }
    },
    'durationFinish'(val) {
      if (val) {

        this.durationF = val;

        if (this.beforeFinish || this.isStartTime) {
          this.duration = val;
          this.beforeStart = false;
          this.beforeFinish = true;
        }

        this.start(true);
      }
    },
    'durationS'(val) {

      if (val < 1)
        this.beforeStart = false;

      this.beforeFinish = val < 1;
    },
    'durationF'(val) {

      if (val < 1) {
        if (!this.isTesting)
          this.emitEventOver();
        else
          this.emitTimeUp();
      }
    }
  },
  methods: {
    checkForDates() {

      if (this.durationS === false || this.stopped) {
        this.stopped = false;
        this.durationS = this.durationStart;
      }

      if (this.durationF === false || this.stopped) {
        this.stopped = false;
        this.durationF = this.durationFinish;
      }


      if (this.durationS > 1) {
        this.beforeStart = true;
        this.duration = this.durationS;
        return true;
      } else if (this.durationF < 1) {

        if (this.isTesting)
          this.emitTimeUp();
        else
          this.emitEventOver();

        this.duration = 0;
        return true;
      } else {
        this.beforeStart = false;
        this.beforeFinish = true;
        this.duration = this.durationF;
        return true;
      }

    },
    emitStartEvent() {
      this.$emit('start', this.testId);
    },
    emitTimeUp() {
      this.$emit('over', true);
    },
    emitEventOver() {
      this.$emit('eventOver', true);
    },
    start(force = false) {
      if (!this.timer || force) {
        this.stop();
        this.timer = setInterval(() => {
          if (!this.isPaused) {
            if (this.duration > 0) {

              this.duration--;

              if (this.beforeStart)
                this.durationS--;

              if (this.beforeFinish)
                this.durationF--;
            }
          }
        }, 1000)
      }
    },
    pause() {
      this.isPaused = true;
    },
    stop() {
      clearInterval(this.timer);
      this.timer = null;
      this.stopped = true;
    },
    reset() {
      this.stop();
      this.duration = 0;
    },
  },
  filters: {
    prettify: function (value) {
      let data = value.split(':');
      let hours = data[0];
      let minutes = data[1];
      let seconds = data[2];

      if (hours < 10)
        hours = "0" + hours;
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return hours + ":" + minutes + ":" + seconds;
    }
  }
}
</script>

<style scoped>
.timer--early {
  color: #2fd485 !important;
}

.auth-timer-label {
  margin-right: 10px;
}

.auth-timer {
  position: relative;
  bottom: 12px;
}

</style>
